import { create } from "zustand";
import type { ICreator } from "../types/models/creator.models.types";
import type { IPayoutMethod } from "../hooks/http/admin/kyc/creators/approve-payout.admin.http";


export type KycRowData = (ICreator | IPayoutMethod) & {
  id: string;
  user?: { name: string; email: string };
};

interface IKycApprovalsStore {
  data: KycRowData[];
  setData: (data: KycRowData[]) => void;
  appendData: (data: KycRowData[]) => void;
  removeById: (id: string) => void;
}

const useKycApprovalsStore = create<IKycApprovalsStore>((set) => ({
  data: [],
  setData: (data) => set({ data }),
  appendData: (newData) =>
    set((state) => ({ data: [...state.data, ...newData] })),
  removeById: (id) =>
    set((state) => ({
      data: state.data.filter((item) => item.id !== id),
    })),
}));

export default useKycApprovalsStore;
